const PREFERRED_USER_ORDER = ["ramya", "kavya", "tejas"];

const getUserOrder = (user) => {
  const identity = String(user?.name || user?.username || "")
    .trim()
    .toLowerCase();
  const preferredIndex = PREFERRED_USER_ORDER.indexOf(identity);
  return preferredIndex === -1 ? PREFERRED_USER_ORDER.length : preferredIndex;
};

export const sortUsersByPreferredOrder = (users) => {
  if (!Array.isArray(users)) return users;

  return [...users].sort(
    (firstUser, secondUser) =>
      getUserOrder(firstUser) - getUserOrder(secondUser),
  );
};
